import moment from "moment";
import { SortOrder, TableFilterState } from "./components/dcTable";

export interface PaginationData {
    skip: number,
    take: number,
    entityCount: number
}
export const beautifyDate = (date?: Date) => {
    if (date == null || date == undefined) return null;

    return moment(date).format("DD/MM/yyyy HH:mm")
}
export const convertArrayBufferToBase64 = (buffer: ArrayBuffer) => {
    let binaryString = ''
    var bytes = new Uint8Array(buffer);
    for (var i = 0; i < bytes.byteLength; i++) {
        binaryString += String.fromCharCode(bytes[i]);
    }

    return window.btoa(binaryString);
}
export const sortOnFilter = (filter: TableFilterState, colClicked: string) => {
    var copy = { ...filter };
    copy.sortColumn = colClicked;
    if (copy.sortOrder == null) {
        copy.sortOrder = SortOrder.DESC;
    } else {
        if (copy.sortOrder == SortOrder.ASC) {
            copy.sortOrder = SortOrder.DESC;
        } else {
            copy.sortOrder = SortOrder.ASC
        }
    }
    return copy;
}
export const getPageSkipTake = (skip: number, take: number): number => {
    return getPagination(skip, take);
}
export const getPage = (paginationData: PaginationData): number => {

    return getPagination(paginationData.skip, paginationData.take);
}
export const getPagination = (skip: number, step: number): number => {

    if (skip == 0) return 0;

    return (skip / step);
}
export const getSkip = (page: number, rowsPerPage: number): number => {
    if (page == 0) return 0;

    return rowsPerPage * (page);
}